import React from 'react'
import './About.css';

const About = () => {
  return (
    <div>
						<div class="elementor-element elementor-element-231b410 start elementor-widget_width-initial elementor-widget-mobile_extrawidth-initial elementor-widget-mobile_width-inherit elementor-widget elementor-widget-wdt-heading" data-id="231b410" data-element_type="widget" data-settings="{&quot;wdt_animation_effect&quot;:&quot;none&quot;}" data-widget_type="wdt-heading.default">
				<div class="elementor-widget-container">
			<div class="wdt-heading-holder" id="wdt-heading-231b410">
				<div class="wdt-heading-subtitle-wrapper wdt-heading-align-center">
				<span class="wdt-heading-subtitle-title" style={{color:"green"}}>About Us</span></div>
			<h2 class="wdt-heading-title-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
				<span class="wdt-heading-title-align-center">Globally Recognized Interactive Preschool Education</span></h2></div>		</div>
				</div>
				{/* <div class="elementor-element elementor-element-2e531c6 start elementor-widget_width-initial elementor-widget-mobile_extra_width-inherit elementor-widget elementor-widget-wdt-heading" data-id="2e531c6" data-element_type="widget" data-settings="{&quot;wdt_animation_effect&quot;:&quot;none&quot;}" data-widget_type="wdt-heading.default">
				<div class="elementor-widget-container">
			<div class="wdt-heading-holder" id="wdt-heading-2e531c6">
				<div class="wdt-heading-content-wrapper">Our preschool education program is designed to meet global standards, incorporating the best practices from around the world. We offer an interactive learning environment where children are encouraged to explore, question, and discover.</div></div>		</div>
				</div> */}
				<div>
					</div>
					</div>
  )
}

export default About;